var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "68px",
    height: "59px",
    viewBox: "0 0 68 59",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C51D7EB6-CE62-4FC1-9A0B-8C2FE37278FC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "indigo-blue",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#192CF8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18B0F4",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Warning-SVG",
    transform: "translate(-686.000000, -283.000000)",
    fill: "url('#indigo-blue')"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Modal",
    transform: "translate(490.000000, 223.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.999929,60 C228.383664,60 226.845701,60.8507523 226.029305,62.2348463 L196.613129,112.211578 C195.796608,113.599597 195.79464,115.350465 196.613129,116.737142 C197.500214,118.239853 199.299222,119.003991 200.9193,118.999984 L259.080558,118.999984 C260.701002,118.999984 262.499681,118.239674 263.38673,116.737142 C264.205407,115.350465 264.203439,113.599597 263.38673,112.211578 L233.970553,62.2348463 C233.154157,60.8507434 231.616195,60 229.999929,60 Z M229.999929,61.787877 C230.953371,61.787877 231.934041,62.3308732 232.404673,63.1287848 L261.84881,113.133497 C262.319524,113.933483 262.320687,115.043933 261.84881,115.843203 C261.445287,116.526709 260.035136,117.214773 259.080558,117.212099 L200.9193,117.212099 C199.964372,117.212099 198.554499,116.526619 198.151047,115.843203 C197.67927,115.043933 197.680433,113.933483 198.151047,113.133497 L227.595185,63.1287848 C228.065817,62.3308821 229.046505,61.787877 229.999929,61.787877 Z M229.999929,78.7727087 C229.505737,78.7727087 229.105141,79.172925 229.105141,79.6666472 L229.105141,99.3333213 C229.105141,99.8270435 229.505737,100.22726 229.999929,100.22726 C230.494121,100.22726 230.894718,99.8270435 230.894718,99.3333213 L230.894718,79.6666472 C230.894718,79.172925 230.494121,78.7727087 229.999929,78.7727087 Z M229.999929,106.484829 C229.011572,106.484829 228.210352,107.285262 228.210352,108.272706 C228.210352,109.260151 229.011572,110.060583 229.999929,110.060583 C230.988286,110.060583 231.789506,109.260151 231.789506,108.272706 C231.789506,107.285262 230.988286,106.484829 229.999929,106.484829 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningModal);
export default __webpack_public_path__ + "static/media/warning-modal.ffc2c4b416e4feed8271fe6c38692858.svg";
export { ForwardRef as ReactComponent };